import { createPortal } from 'react-dom';

import PropTypes from 'prop-types';

import styles from './MobileCommentDetailModal.module.scss';

/**
 * 모바일 코멘트 상세 모달 컴포넌트 (바텀시트 스타일)
 * - 피그마 디자인: 아래에서 올라오는 바텀시트
 * - 코멘트 내용 + 수정/삭제 버튼 (소유자인 경우)
 */
function MobileCommentDetailModal({ isOpen, comment, isOwner, onClose, onModify, onDelete }) {
  if (!isOpen || !comment) {
    return null;
  }

  const commentText = comment.comment || comment.content || '';

  function handleBackdropClick(event) {
    if (event.target === event.currentTarget) {
      onClose();
    }
  }

  return createPortal(
    <div className={styles.backdrop} onClick={handleBackdropClick}>
      <div className={styles.bottomSheet}>
        {/* 헤더 */}
        <div className={styles.header}>
          <h3 className={styles.title}>코멘트</h3>
        </div>

        {/* 코멘트 내용 */}
        <div className={styles.content}>
          <div className={styles.commentBox}>
            <p className={styles.commentText}>{commentText}</p>
          </div>
        </div>

        {/* 버튼 영역 */}
        <div className={styles.footer}>
          {isOwner ? (
            <div className={styles.buttonGroup}>
              <button type="button" className={styles.actionButton} onClick={onDelete}>
                삭제
              </button>
              <button type="button" className={styles.actionButton} onClick={onModify}>
                수정
              </button>
              <button
                type="button"
                className={`${styles.actionButton} ${styles.primaryButton}`}
                onClick={onClose}
              >
                확인
              </button>
            </div>
          ) : (
            <button
              type="button"
              className={`${styles.actionButton} ${styles.primaryButton} ${styles.fullWidth}`}
              onClick={onClose}
            >
              확인
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}

MobileCommentDetailModal.propTypes = {
  isOpen: PropTypes.bool,
  comment: PropTypes.shape({
    idx: PropTypes.number,
    name: PropTypes.string,
    date: PropTypes.string,
    comment: PropTypes.string,
    content: PropTypes.string,
  }),
  isOwner: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onModify: PropTypes.func,
  onDelete: PropTypes.func,
};

MobileCommentDetailModal.defaultProps = {
  isOpen: false,
  comment: null,
  isOwner: false,
  onModify: null,
  onDelete: null,
};

export default MobileCommentDetailModal;
